import { Button, Drawer, Dropdown, Tooltip } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./detail.module.less";
import Empty from "@/components/Supervise/components/empty";
import { Avatar } from "@/baseComponents/Avatar";
import { convertEmployeeToString, getUnitTitleInfo } from '@/utils/chat/message';
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { formate } from "@/utils/date";
import Bus from "@/utils/bus";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import { QuickReplyStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Text";
import { tagsNode } from "@jd/focus-desktop-comps/lib/es/UserCard/common";

function QuickReplyDetail(props: any) {
  const { detailVisible, handleClose, replyUsers, quickReplys, openUserCard, currSelected } = props;
  const [currTab, setCurrTab] = useState(currSelected);
  const visibleChange = (e: MouseEvent) => {
    if (detailVisible) {
      Bus.emit("message-item-chatitem", true);
    }
  };
  useEffect(() => {
    document.addEventListener("contextmenu", visibleChange);
    return () => {
      document.removeEventListener("contextmenu", visibleChange);
    };
  });

  const itemsComp = useCallback(
    (u: any) => {
      return (
        <div
          className={styles["item"]}
          key={convertEmployeeToString(u)}
          onClick={() => openUserCard(u)}
        >
          <Avatar
            className={styles["avatar"]}
            src={getHeadImgThumbUrl(u.avatar, 150, 150)}
            name={u.name}
          />
          <div className={styles["info"]}>
            <div className={styles["name-wrap"]}>
              <span className={`${styles["name"]} ellipsis`}>{u.name}</span>
              {u.labelInfoList ? tagsNode(u.labelInfoList) : null}
              <span className={styles["time"]}>{formate(u.timeStamp, true)}</span>
            </div>
            <span className={`${styles["unit"]} ellipsis`}>
              {getUnitTitleInfo(u.unitName, u.titleName)}
            </span>
          </div>
        </div>
      );
    },
    [openUserCard]
  );

  // footer
  const DrawerFooter = useMemo(() => {
    return null;
  }, []);

  const getStyle = useCallback(
    (code: string, text: string) => {
      const item = quickReplys.find((i: any) => i.id === code || i.detail === text);
      return {
        background: item?.backgroundColor || "",
        borderColor: item?.frameColor || "",
        color: item?.textColor || "",
        "--color": item?.hoverColor || ""
      };
    },
    [quickReplys]
  );

  const getItemStyle = useCallback(
    (code: string, text: string) => {
      const item = quickReplys.find((i: any) => i.id === code || i.detail === text);
      return {
        borderColor: `${item?.textColor}`
      };
    },
    [quickReplys]
  );

  const replyComp = useMemo(() => {
    return (
      <div className={styles["info-wrap"]}>
        {replyUsers?.length
          ? replyUsers.map((item: any) => {
              item.users = item.users || [];
              const len = item.users.length;
              const style = getStyle(item.emojiCode, item.text);
              const itemStyle =
                item.emojiCode === currTab ? getItemStyle(item.emojiCode, item.text) : {};
              return (
                <div
                  style={itemStyle}
                  className={styles["item"]}
                  key={`reply_${item.emojiCode}`}
                  onClick={() => setCurrTab(item.emojiCode)}
                >
                  <div className={styles["tag"]} style={style}>
                    {item.text}
                  </div>
                  <span className={styles["name"]}>{`+${len}人`}</span>
                </div>
              );
            })
          : null}
      </div>
    );
  }, [currTab, getItemStyle, getStyle, replyUsers]);

  const currUsers = useMemo(() => {
    const item = replyUsers.find((i: any) => i?.emojiCode === currTab);
    if (item?.users?.length) {
      return item.users;
    } else {
      return [];
    }
  }, [currTab, replyUsers]);

  const total = useMemo(() => {
    return replyUsers?.length ? replyUsers.reduce((a: any, b: any) => {
          return a + (b?.users?.length || 0);
        }, 0)
      : 0;
  }, [replyUsers]);

  return (
    <Drawer
      title={
        <div className={styles["drawer-title"]}>
          <span className={styles["drawer-title-name"]}>{`表情回复详情（${total}）`}</span>
        </div>
      }
      className={styles["reply-emoji-detail-drawer"]}
      placement="right"
      width={310}
      onClose={handleClose}
      visible={detailVisible}
      destroyOnClose={true}
      maskClosable={true}
      footer={DrawerFooter}
    >
      {!replyUsers?.length ? (
        <Empty text="暂无回复" />
      ) : (
        <>
          {replyComp}
          <div className={styles["user-list"]}>
            {currUsers.map((u: any) => {
              return itemsComp(u);
            })}
          </div>
        </>
      )}
    </Drawer>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, quickReplys } = chat;
  return {
    currentEmployee,
    quickReplys
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(QuickReplyDetail);
